import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "addressBook_container" }
const _hoisted_2 = { class: "popTitle" }
const _hoisted_3 = { class: "mainTab" }
const _hoisted_4 = { class: "subTab" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "btn_container" }

import { AddressChannelItem, callAddressBook, NetworkChannelItem, TAB_ADDRESSBOOK, TAB_SUB_ADDRESSBOOK } from '@/view/withdraw/supportScript';
import { ref } from 'vue';
import AddressBookCard from './addressBookCard.vue';
import MainButton from '../../components/common/mainButton.vue';
import AddAddressPopup from './addAddressPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'addressBookPopup',
  emits: ['onClickTab', 'onClickSubTab', 'callNetworkOptions'],
  setup(__props, { expose: __expose, emit: __emit }) {

const show = ref(false);
const activeSub = ref(0)
const active = ref(0)
const tabList = ref(TAB_ADDRESSBOOK)
const subTabList = ref(TAB_SUB_ADDRESSBOOK)
const filterType = ref(1)
const networkType = ref(0)
const addressList = ref<AddressChannelItem[]>([])
const addAddressRef = ref()
const emits = __emit
const openPopup = () => {
    fetchAddressBook()
    show.value = true;
}

const closePopup = () => {
    show.value = false;
}
const onClickTab = (data: any) => {
    filterType.value = data.name
    fetchAddressBook()
}
const onClickSubTab = (data: any) => {
    networkType.value = data.name
    fetchAddressBook()
}
const openAddAddressPopup = () => {
    addAddressRef.value.openPopup()
}
const fetchAddressBook = async () => {
    const { addresses } = await callAddressBook(filterType.value, networkType.value)
    addressList.value = addresses
}
__expose({
    openPopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    "overlay-style": { overflow: 'hidden' },
    style: {
        minWidth: '100%',
        height: '70%',
        color: '#fff',
    },
    class: "addressPopup"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('withdraw.selectAddress')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_tabs, {
            modelValue: active.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
            ellipsis: false,
            onClickTab: onClickTab
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_tab, {
                  key: index,
                  title: _ctx.$t(item.name),
                  name: item.id
                }, null, 8, ["title", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_tabs, {
            active: activeSub.value,
            "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((activeSub).value = $event)),
            ellipsis: false,
            onClickTab: onClickSubTab
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTabList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_tab, {
                  key: index,
                  title: _ctx.$t(item.name),
                  name: item.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressList.value, (item, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createVNode(AddressBookCard, {
                            "channe-label": item.address_label,
                            address: item.address,
                            "chain-type": item.chain_type,
                            onUpdateAddressBook: fetchAddressBook
                          }, null, 8, ["channe-label", "address", "chain-type"])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(MainButton, {
                          title: _ctx.$t('withdraw.addNewAddress'),
                          activeStatus: true,
                          onClick: openAddAddressPopup,
                          radius: '10'
                        }, null, 8, ["title"])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["title", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["active"])
        ])
      ]),
      _createVNode(AddAddressPopup, {
        ref_key: "addAddressRef",
        ref: addAddressRef,
        onUpdateAddressbook: fetchAddressBook,
        onCallNetworkOptions: _cache[2] || (_cache[2] = (value) => emits('callNetworkOptions', value))
      }, null, 512)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})